export default __webpack_public_path__ + "static/media/nav-icon.ac2c4773.png";